export default "__VITE_ASSET__DaBqEKRK__"